/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Status_Preparing_VideoInputs */



/**
* | output |
* | --- |
* | "Preparing video export..." |
*
* @param {Audio_Description_Export_Status_Preparing_VideoInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_status_preparing_video = /** @type {((inputs?: Audio_Description_Export_Status_Preparing_VideoInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Status_Preparing_VideoInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Préparation de l'exportation vidéo...")
	if (locale === "de") return /** @type {LocalizedString} */ ("Videoexport wird vorbereitet...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Preparazione dell'esportazione video...")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Подготовка к экспорту видео...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Preparando exportación de vídeo...")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("正在准备视频导出……")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ビデオのエクスポートを準備しています...")
	if (locale === "hi") return /** @type {LocalizedString} */ ("वीडियो निर्यात की तैयारी हो रही है...")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Preparando a exportação de vídeo...")
	return /** @type {LocalizedString} */ ("Preparing video export...")
});